module.exports = __webpack_public_path__ + "static/img/1.3bfb6d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shangji/1.png
// module id = OwB2
// module chunks = 1